const WOO_BASE_URL = 'https://gemnoble.com/wp-json/wc/v3';
const WOO_TOKEN = 'Y2tfMTc3NjU5ZmFmYmRhM2I4MzAzYThlZDNkN2VhYmMzYjY4ZjlhYTc0OTpjc19kYmFiNTgyODFjMzFhMTFiZDc0ZGE1MTM2OWQ2N2ViNzRhNzIyODdl';

const wooHeaders = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Basic ${WOO_TOKEN}`);
    return headers;
};

export const createWooProduct = (productData) => {
    return new Promise((resolve, reject) => {
        fetch(`${WOO_BASE_URL}/products/`, {
            method: 'POST',
            headers: wooHeaders(),
            body: JSON.stringify(productData),
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => resolve(JSON.parse(result)))
            .catch(error => reject(error));
    });
};

export const updateWooProduct = (id, productData) => {
    return new Promise((resolve, reject) => {
        fetch(`${WOO_BASE_URL}/products/${id}`, {
            method: 'PUT',
            headers: wooHeaders(),
            body: JSON.stringify(productData),
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => resolve(JSON.parse(result)))
            .catch(error => reject(error));
    });
};

export const deleteWooProduct = (id) => {
    return new Promise((resolve, reject) => {
        fetch(`${WOO_BASE_URL}/products/${id}?force=1`, {
            method: 'DELETE',
            headers: wooHeaders(),
            redirect: 'follow'
        })
            .then(response => response.text())
            .then(result => resolve(JSON.parse(result)))
            .catch(error => reject(error));
    });
};
